import { FetchedDownstreamHandlingTypes } from "./api/sanity/types";

export type FlatDownstreamObject = {
  name: string;
  parentIds: string[];
  /** Own colour, or the closest parent's when it has none. */
  color?: string;
};

export type FlatDownstreamData = {
  [k: string]: FlatDownstreamObject;
};

export const getFlatDownstreamData = (data: FetchedDownstreamHandlingTypes) => {
  return data.reduce((acc, d) => {
    acc[d._id] = {
      name: d.name,
      parentIds: [],
      color: d.color || undefined,
    };

    if (d.children) {
      const childrenData = getFlatDownstreamData(d.children);

      Object.keys(childrenData).forEach((cKey) => {
        acc[cKey] = {
          name: childrenData[cKey].name,
          parentIds: [d._id],
          color: childrenData[cKey].color || d.color || undefined,
        };

        if (childrenData[cKey].parentIds.length) {
          acc[cKey].parentIds.push(...childrenData[cKey].parentIds);
        }
      });
    }

    return acc;
  }, {} as FlatDownstreamData);
};
